import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Background from '../../../domain/entities/Background';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBackgroundsSuccess: {
      const result = action.payload as PaginatedResult<Background>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
